module.exports = __webpack_public_path__ + "img/Intel64_48.22b8f5e2.png";